var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',[_c('router-view'),_c('Snackbar'),_c('LoadingPage',{attrs:{"showLoading":_vm.loadingPage}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }